import { OrderKeys } from '~src/spacesPlatform/models/OrderKeys';
import { SortOptions } from '~src/spacesPlatform/models/sort/CommonSortOptions';
import { Order } from '~src/spacesPlatform/models/sort/Order';
import { OptionsDictionary } from '~src/spacesPlatform/models/sort/SortOptionDefinitions';
import { IOrderClause } from '~src/spacesPlatform/serverApi/types/IOrderClause';
import { workbookNameSortOption } from '~src/views/models/sort/ViewSortOptions';

export const broadcastsSpaceDefaultSortOrder: IOrderClause[] = [Order.asc(OrderKeys.name)];

export const broadcastsSortOptions: OptionsDictionary = {
    'name':SortOptions.name,
    'owner': SortOptions.owner,
    'updated': SortOptions.updated,
    'workbook': workbookNameSortOption,
    'sheet': SortOptions.sheetIndex,
    'locationName': SortOptions.locationName,
};
